import { render, staticRenderFns } from "./GraphDetail81.vue?vue&type=template&id=87e8a34e&scoped=true"
import script from "./GraphDetail81.vue?vue&type=script&lang=js"
export * from "./GraphDetail81.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e8a34e",
  null
  
)

export default component.exports